module.exports = __webpack_public_path__ + "files/0a5ebf757c2c9a8c61d72bdd16de51c5.png";